export function normalizeClientRow(raw) {
  if (!raw) return {};
  return {
    ...raw,
    id: raw.id,
    companyName: raw.companyName ?? raw.company_name ?? "",
    contactEmail: raw.contactEmail ?? raw.contact_email ?? "",
    industry: raw.industry ?? "-",
    companySize: raw.companySize ?? raw.company_size ?? "-",
    createdAt: raw.createdAt ?? raw.created_at ?? "",
    blockingReason: raw.blockingReason ?? raw.blocking_reason ?? "",
    isBlocked: raw.isBlocked ?? raw.is_blocked ?? false,
    isActive: raw.isActive ?? raw.is_active ?? false,
    isEstablished: raw.isEstablished ?? raw.is_established ?? false,
  };
}
